<template>
    <div
        v-if="currentSku && canShowEstAvailableDate"
        class="d-flex justify-space-between"
    >
        <v-chip
            class="text-uppercase"
            :color="statusColor"
            size="x-small"
            label
        >
            {{ statusText }}
        </v-chip>
        <span
            class="font-size-8"
        >
            Ships {{ currentSku.availableDate }}
        </span>
    </div>
</template>

<script lang="ts" setup>
    import type {
        BundleTemplateLineSkuData
    } from '~/types';
    import {
        useGetStatusColor,
        useProductAvailabilityStatus
    } from '~/composables';
    import {
        ProductAvailabilityStatus
    } from '~/types';

    const props = defineProps<{
        currentSku: BundleTemplateLineSkuData;
    }>();

    const {
        statusText,
        canShowEstAvailableDate
    } = useProductAvailabilityStatus(props.currentSku.status as ProductAvailabilityStatus);

    const statusColor = ref(useGetStatusColor(props.currentSku.status));
</script>

<style lang="scss"></style>
